<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px;height: auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Vehicle Movement Tracking Utility</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <!-- <b-button
              class="pull-right"
              v-if="addM==false"
              variant="warning"
              size="sm"
              @click="addManual"
            >Add Activity Manually</b-button>-->
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="AllDetails.allModuleId ? AllDetails.allModuleId : ''"
          :jobSeriesBanner="AllDetails.salesSeries ? AllDetails.salesSeries : ''"
          :bannerClientName="AllDetails.clientName ? AllDetails.clientName : ''"
          iconId="fa fa-ship"
        />
        <div>
          <b-card class="formCard">
            <b-card-text>
              <table class="table table-sm table-bordered table-striped table-responsive">
                <tbody>
                  <tr>
                    <td>
                      <b>Ass.No:{{ AllDetails.salesSeries }}</b>
                    </td>
                    <td>
                      <b>Client:{{ AllDetails.clientName }}</b>
                    </td>
                    <td>
                      <b>PICK:{{ AllDetails.PICK }}</b>
                    </td>
                    <td>
                      <b>Stuff:{{ AllDetails.STUFF }}</b>
                    </td>
                    <td>
                      <b>HOV:{{ AllDetails.HAND }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div>
                <span class="error">Disable Same for all</span>
                <b-form-radio
                  v-model="selectedSame"
                  name="some-radios"
                  value="G"
                ></b-form-radio>
                <table class="table table-sm table-bordered table-striped table-responsive">
                  <br />

                  <tbody>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Vehicle No</th>
                      <th scope="col">Container</th>
                      <th scope="col">
                        Dispatch date ( Departed from ICD)
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="A"
                        ></b-form-radio>
                      </th>
                      <th scope="col">
                        Stuffing / De-stuffing Date
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="B"
                        ></b-form-radio>
                      </th>
                      <th scope="col">
                        Arrival at Factory
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="C"
                        ></b-form-radio>
                      </th>
                      <th scope="col">
                        Dispatch from Factory
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="D"
                        ></b-form-radio>
                      </th>
                      <th scope="col">
                        Arrival at Port / ICD
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="E"
                        ></b-form-radio>
                      </th>
                      <th scope="col">
                        Vehicle Release Date
                        <br />
                        <span class="error">Same for all</span>
                        <b-form-radio
                          style="
                            margin-top: -22px !important;
                            margin-left: 82px !important;
                          "
                          v-model="selectedSame"
                          name="some-radios"
                          value="F"
                        ></b-form-radio>
                      </th>
                      <th scope="col">status</th>
                    </tr>

                    <tr v-for="(item, indx) in consoGRNMail" :key="indx">
                      <th scope="row">{{ indx + 1 }}</th>
                      <th scope="row">{{ item.vehicleNo }}</th>
                      <td>{{ item.containerNo }}</td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleDispatchDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleStuffingDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleFactoryAriveDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleFactoryDispatchDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleAriveAtPortDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                          @input="renderSameForAll(item)"
                          style="width: 140px"
                          v-model="item.vehicleReleaseDate"
                          lang="en"
                          value-type="format"
                          format="YYYY-MM-DD"
                        ></date-picker>
                        <!-- :disabled="(item.vehicleReleaseDate!='' &&item.status==2)?true:false" -->
                      </td>
                      <td>
                        <md-checkbox
                          :style="`${
                            item.vehicleReleaseDateAdded == 1
                              ? 'cursor: not-allowed;'
                              : !item.vehicleReleaseDate
                              ? 'cursor: not-allowed;'
                              : ''
                          }`"
                          v-model="item.status"
                          :md-value="item.status"
                          class="md-primary"
                          name="status"
                          id="status"
                          :disabled="
                            item.vehicleReleaseDateAdded == 1
                              ? true
                              : !item.vehicleReleaseDate
                              ? true
                              : false
                          "
                        ></md-checkbox>
                        <!-- @change="statusSelect(item.status)" -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <label for="event">Activity Status</label>

                  <model-list-select
                    :isDisabled="emailModal.transportMailId==''?false:true"
                    :list="emailBody"
                    @input="getContent"
                    v-model="emailModal.event"
                    option-value="contentId"
                    option-text="event"
                    placeholder="Select Activity"
                  ></model-list-select>
                  <span class="error" v-if="!emailModal.event">{{errorSend.event}}</span>
                </md-layout>
              </md-layout>-->
              <!-- <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <label for="vehicleTruckId">Vehicle No.</label>

                  <model-list-select
                    :list="vehicleList"
                    :isDisabled="emailModal.transportMailId==''?false:true"
                    v-model="emailModal.vehicleTruckId"
                    option-value="vehicleTruckId"
                    option-text="regdNo"
                    placeholder="Select Vehicle"
                  ></model-list-select>
                  <span class="error" v-if="!emailModal.vehicleTruckId">{{errorSend.vehicleTruckId}}</span>
                </md-layout>
              </md-layout>-->

              <!-- <md-layout md-gutter class="gutr" v-if="emailModal.event == '11'">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Email Content</label>
                  </md-layout>
                  <md-layout md-flex="100">
                    <quill-editor
                      :disabled="emailModal.event==''?true:false"
                      style="width:100% !important;height:270px !important"
                      v-model="emailModal.emailContent"
                    ></quill-editor>
                  </md-layout>
                </md-layout> 
              </md-layout>-->
              <!-- <md-layout md-gutter class="gutr" v-if="emailModal.event == '11'">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <label>Client Email</label>
                  <b-form-input
                    name="clientEmail"
                    id="clientEmail"
                    v-model="emailModal.clientEmail"
                  ></b-form-input>
                </md-layout>
              </md-layout>-->
              <!-- <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <label>Add Cc.(if Any)</label>
            <b-form-input name="mailCC" id="mailCC" v-model="emailModal.mailCC"></b-form-input>
              </md-layout>-->
              <md-layout md-gutter class="justify-content-center">
                <md-layout md-flex="5">
                  <b-button
                    style="width: 100px;margin-bottom: 10px;"
                    :disabled="emailModal.transportMailId == '' ? false : true"
                    @click="sendMail"
                    id="sendLoaderMain"
                    variant="primary"
                    >Save</b-button
                  >

                  <md-spinner
                    md-indeterminate
                    id="sendLoader"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
                <div class="table-striped table-responsive"
                  v-if="
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                    $sessionsStorage.get('cust_username') == 'vikramsingh' ||
                    $sessionsStorage.get('cust_username') == 'gouravmishra'
                  "
                >  
                  <h5>
                    <b-badge variant="info">GPS Fetch Transported Details</b-badge>
                  </h5>

                  <table class="table table-sm table-bordered">
                    <br />
                    <tbody>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Vehicle No</th>
                        <th scope="col">Container</th>
                        <th scope="col">
                          Dispatch Date ( Departed from ICD)(Pickup Out Time)
                        </th>
                        <th scope="col">Stuffing / De-stuffing Date(Factory IN Time)</th>
                        <th scope="col">Arrival at Factory(Factory IN Time)</th>
                        <th scope="col">Dispatch from Factory(Factory Out Time)</th>
                        <th scope="col">Arrival at Port / ICD(Handover In Time)</th>
                        <th scope="col">Vehicle Release Date</th>
                        <th scope="col">Status</th>
                      </tr>

                      <tr v-for="(item, indx) in consoGPSGRNMail" :key="indx">
                        <th
                          scope="row"
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          {{ indx + 1 }}
                        </th>
                        <th
                          scope="row"
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          {{ item.vehicleNo }}
                          <br />

                          <span>GRN Series : {{ item.GRNSeries }}</span>

                          <br />
                          <span>GRN Date : {{ item.Date }}</span>
                          <span
                            >Type :
                            {{ item.tptType == 1 ? "Pridel" : "Outsourced" }}</span
                          >
                        </th>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          {{ item.containerNo }}
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{ getDateFormate(item.gps_vehicle_dispatch_date) }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_dispatch_date_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_dispatch_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_dispatch_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_dispatch_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{ getDateFormate(item.gps_vehicle_stuffing_date) }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_stuffing_date_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_stuffing_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_stuffing_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_stuffing_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{
                            getDateFormate(item.gps_vehicle_factory_arive_date)
                          }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_factory_arivedate_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_factory_arive_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_factory_arive_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_factory_arive_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{
                            getDateFormate(item.gps_vehicle_factory_dispatch_date)
                          }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_factory_dispatch_date_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_factory_dispatch_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_factory_dispatch_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_factory_dispatch_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{
                            getDateFormate(item.gps_vehicle_arive_at_port_date)
                          }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_arive_at_port_date_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_arive_at_port_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_arive_at_port_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_arive_at_port_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{ getDateFormate(item.gps_vehicle_release_date) }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_release_date_loc }}</span>
                          <br />
                          <span>{{ item.gps_vehicle_release_date_dist }}</span><br />
                          <span>Lat : {{ item.gps_vehicle_release_date_lati }}</span><br />
                          <span>Long : {{ item.gps_vehicle_release_date_longi }}</span>
                          <br />
                        </td>
                        <td
                          :style="
                            item.tptType == 1
                              ? ''
                              : 'background:#f28877;color:white;font-weight:bold'
                          "
                        >
                          <span>{{
                            item.gps_vehicleReleaseDateAdded == 1
                              ? "Released"
                              : "Not Released"
                          }}</span>
                          <br />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- <md-layout md-flex="15">
                  <b-button
                    v-if="emailModal.transportMailId!=''"
                    size="sm"
                    variant="info"
                    style="margin:0px"
                    @click="clearAll"
                  >New Activity</b-button>
                </md-layout>-->
              </md-layout>

              <!-- <div class="box">
                <div class="box-header">
                
                </div>
                <div>
                  <h2
                    v-if="showMailDetails.length==0"
                    class="box-title error"
                    style="text-align:center !important"
                  >No Activity For This Assignment..!</h2>
                </div>
              </div>-->
            </b-card-text>
          </b-card>
        </div>
        <div class="box-body mt-3" v-if="showMailDetails.length > 0">
          <table id="truckDetail2" style="background: white" class="table tableSecondry">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Event</th>
                <th>Vehicle No.</th>

                <th>Date & Time</th>
                <th>Updated By</th>
                <th>Current Location</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in showMailDetails"
                :key="index"
                @click="editMail(item)"
                class="showMoreData"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.eventName }}</td>
                <td>{{ item.vehicleTruckId == 0 ? "----" : item.regdNo }}</td>

                <td>{{ item.loginTime | moment }}</td>
                <td>{{ item.fromGps == "1" ? "GPS" : "SYSTEM" }}</td>
                <td>
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="showDirection(item.vehicleTruckId)"
                  >
                    <md-icon>pin_drop</md-icon>
                  </md-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import BannerComponent from "../../allModuleForm/bannerComponent.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      alert: {
        content:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      //   statusList: [
      //     {
      //       activityStatusV: "Released_From_Hub",
      //       activityStatusT: "Vehicle Released From Hub"
      //     },
      //     {
      //       activityStatusV: "Arrived_At_ICD",
      //       activityStatusT: "Vehicle Arrived At ICD"
      //     },
      //     {
      //       activityStatusV: "Departed_From_ICD",
      //       activityStatusT: "Vehicle Departed From ICD"
      //     },
      //     {
      //       activityStatusV: "Arrived_At_Factory_Location",
      //       activityStatusT: "Vehicle Arrived At Factory Location"
      //     },
      //     {
      //       activityStatusV: "Departed_From_Factory_Location",
      //       activityStatusT: "Vehicle Departed From Factory Location"
      //     },
      //     {
      //       activityStatusV: "Reached_Final_Place_Of_Deleivery",
      //       activityStatusT: " Vehicle Reached At Final Destination"
      //     }
      //   ],
      arrayerrorSend: [
        //"Select Activity "
      ],
      errorSend: {
        // event: ""
        // vehicleTruckId: ""
      },
      AllDetails: {},
      addM: false,
      selectedSame: "G",
      showMailDetails: [],
      consoGRNMail: [],
      consoGPSGRNMail: [],
      vehicleList: [],
      isLoading: false,
      emailBody: [],
      validateTrans: true,
      emailModal: {
        transportMailId: "",
        vehicleTruckId: "",
        event: "",
        emailContent: "",
        clientEmail: "",
        mailCC: "",
        assignId: this.$sessionsStorage.get("storeAssignId"),
        clientName: "",
        clientId: "",
      },
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
  },
  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("backToDetailPage", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
  },
  computed: {},
  watch: {
    // emailModal: {
    //   handler: function(newVal, oldVal) {
    //     if (
    //       this.emailModal.event != "" &&
    //       this.emailModal.transportMailId == ""
    //     ) {
    //       let arry3 = this.emailBody.filter(x => {
    //         return x.contentId == this.emailModal.event;
    //       });
    //       //   console.log(this.AllDetails);
    //       var str = arry3[0].description.replace(
    //         "ASSIGNMENT_SERIES",
    //         this.AllDetails.assignSeries
    //       );
    //       str = str.replace(
    //         "FACTORYLOCATION",
    //         this.AllDetails.StuffingLocation
    //       );
    //       //(/PICKUPLOCATION/g, this.AllDetails.fromLocation)
    //       str = str.replace(/PICKUPLOCATION/g, this.AllDetails.fromLocation);
    //       str = str.replace("FINAL_PLACE", this.AllDetails.toLocation);
    //       str = str.replace("CLIENT_NAME", this.AllDetails.clientName);
    //       str = str.replace("TRUCK_NO", this.AllDetails.vehicleDetails);
    //       str = str.replace("C_TYPE", this.AllDetails.multipleContainerType);
    //       str = str.replace("CONTAINER_NO", this.AllDetails.containerNo);
    //       str = str.replace("GR_TRUCKNO ", this.AllDetails.vehicleNo);
    //       this.emailModal.emailContent = str;
    //     }
    //     // if (this.emailModal.transportMailId == "") {
    //     //   let arry = this.showMailDetails.filter(x => {
    //     //     return x.event == this.emailModal.event;
    //     //   });
    //     // if (arry.length > 0) {
    //     //   this.alert.content = "Event Already Executed";
    //     //   this.$refs["addPop"].open();
    //     //   this.emailModal.event = "";
    //     //   this.emailModal.emailContent = "";
    //     // }
    //     // }
    //   },
    //   deep: true
    // }
  },
  methods: {
    getDateFormate(date) {
      return date;
    },
    renderSameForAll(item) {
      if (this.selectedSame == "A") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleDispatchDate = item.vehicleDispatchDate;
        }
      } else if (this.selectedSame == "B") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleStuffingDate = item.vehicleStuffingDate;
        }
      } else if (this.selectedSame == "C") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleFactoryAriveDate = item.vehicleFactoryAriveDate;
        }
      } else if (this.selectedSame == "D") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleFactoryDispatchDate =
            item.vehicleFactoryDispatchDate;
        }
      } else if (this.selectedSame == "E") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleAriveAtPortDate = item.vehicleAriveAtPortDate;
        }
      } else if (this.selectedSame == "F") {
        for (let i = 0; i < this.consoGRNMail.length; i++) {
          this.consoGRNMail[i].vehicleReleaseDate = item.vehicleReleaseDate;
        }
      }

      //
    },
    showDirection(vehicleID) {
      //console.log(vehicleID);
      this.$sessionsStorage.set("editVehicleId", vehicleID);
      this.$router.push({
        path: "/map",
      });
    },
    getContent() {
      // this.isLoading = true;
      if (this.emailModal.event != "" && this.emailModal.transportMailId == "") {
        let arry3 = this.emailBody.filter((x) => {
          return x.contentId == this.emailModal.event;
        });
        //   console.log(this.AllDetails);
        var str = arry3[0].description.replace(
          "ASSIGNMENT_SERIES",
          this.AllDetails.assignSeries
        );
        str = str.replace("FACTORYLOCATION", this.AllDetails.StuffingLocation);
        //(/PICKUPLOCATION/g, this.AllDetails.fromLocation)
        str = str.replace(/PICKUPLOCATION/g, this.AllDetails.fromLocation);
        str = str.replace("FINAL_PLACE", this.AllDetails.toLocation);
        str = str.replace("CLIENT_NAME", this.AllDetails.clientName);
        str = str.replace(/TRUCK_NO/g, this.AllDetails.vehicleDetails);
        // str = str.replace("TRUCK_NO", this.AllDetails.vehicleDetails);
        str = str.replace("C_TYPE", this.AllDetails.multipleContainerType);
        str = str.replace("CONTAINER_NO", this.AllDetails.containerDetails);
        str = str.replace("GR_TRUCKNO ", this.AllDetails.vehicleNo);
        this.emailModal.emailContent = str;
        let arry = this.showMailDetails.filter((x) => {
          return (
            x.event == this.emailModal.event &&
            this.emailModal.vehicleTruckId == x.vehicleTruckId
          );
        });

        if (arry.length > 0) {
          this.alert.content = "Event Already Executed";
          this.$refs["addPop"].open();
          this.emailModal.event = "";
          this.emailModal.emailContent = "";
        }
        if (this.emailModal.event == "11") {
          let grnStr = "";

          // for (let i = 0; i < this.consoGRNMail.length; i++) {
          //   // Concat Array value to string variable
          //   grnStr += str.replace(
          //     "GRN_NO",
          //     this.consoGRNMail[i].GRNSeries +
          //       "<br>  Client Name : " +
          //       this.AllDetails.clientName +
          //       "<br>  Vehicle No. : " +
          //       this.consoGRNMail[i].vehicleNo +
          //       "<br>  Container Type : " +
          //       this.consoGRNMail[i].multipleContainerType +
          //       "<br>  Container No. : " +
          //       this.consoGRNMail[i].containerNo +
          //       "<br> Shipping Line  : " +
          //       this.consoGRNMail[i].shippingLine +
          //       "<br> S-Line Seal No.  : " +
          //       this.consoGRNMail[i].slineSealNo +
          //       "<br> Custom Seal No.  : " +
          //       this.consoGRNMail[i].customSealNo
          //   );

          //   if (i < this.consoGRNMail.length - 1) {
          //     grnStr += "<br>";
          //   }
          // }

          this.emailModal.emailContent = grnStr;

          console.log(this.emailModal.emailContent);
        }
      }
    },
    addManual() {
      this.addM = true;
    },
    clearAll() {
      Object.keys(this.emailModal).map((x) => {
        this.emailModal[x] = "";
      });
    },
    editMail(item) {
      this.addM = true;
      Object.keys(this.emailModal).map((x) => {
        this.emailModal[x] = item[x] || "";
      });

      window.scroll(0, 25);
    },
    goBack() {
      window.history.go(-1);
      // if (this.$sessionsStorage.get("backToDetailPage") == "22") {
      //   console.log("aa");
      //   this.$router.push({
      //     path: "/listView/viewSalesBooking"
      //   });
      // } else {
      //   console.log("22");
      //   this.$router.push({
      //     path: "/vehicle/vehicleBooking"
      //   });
      // }
    },
    validateSend() {
      let validate_new = true;

      Object.keys(this.errorSend).map((x, index) => {
        if (this.emailModal[x] == "") {
          this.errorSend[x] = this.arrayerrorSend[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    sendMail() {
      //To change status value
      if (this.consoGRNMail.length > 0) {
        let stop = false;
        this.consoGRNMail.forEach((v, i) => {
          if (v.vehicleReleaseDate && v.status == false) {
            alert(`Please select status of vehicle  ${v.vehicleNo}`);
            stop = true;
          }
        });
        if (stop) {
          return false;
        }
        this.consoGRNMail.forEach((v, i) => {
          console.log(v);
          if (v.status == false) {
            this.consoGRNMail[i].status = 1;
          } else {
            this.consoGRNMail[i].status = 2;
          }
        });
      }
      let mail = {
        emailModal: this.emailModal,
        AllDetails: this.AllDetails,
        trackingData: this.consoGRNMail,
      };

      // this.validateSend();
      if (this.validateTrans != false) {
        $("#sendLoaderMain").css("display", "none");
        $("#sendLoader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/transportVehicleTrack_test.php`,
          data: JSON.stringify(mail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#sendLoader").css("display", "none");
              $("#sendLoaderMain").css("display", "block");
              this.alert.content = "Tracking Activity Saved";

              this.$refs["addPop"].open();
              this.getData();
              this.addM = false;
            }
          })
          .catch((error) => {});
      }
    },
    getData() {
      let vehicle_drive = {
        mail: "mail",
        assignId: this.$sessionsStorage.get("storeAssignId"),
      };
      //  this.doLoading();
     this.isLoading = true;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/fetchtransportMails.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            let opnMaualTrack = this.$sessionsStorage.get("consomailORtrack");

            if (data.contentDetails.length > 0) {
              this.emailBody = data.contentDetails;
            }
            if (data.mailData.length > 0) {
              this.AllDetails = data.mailData[0];
              this.emailModal.clientName = data.mailData[0].clientName;
              this.emailModal.clientId = data.mailData[0].clientId;
            }
            // this.emailModal.clientEmail = data.mailData[0].email;
            if (data.VehicleArray.length > 0) {
              this.vehicleList = data.VehicleArray;
            }

            if (data.updateMailData.length > 0) {
              this.showMailDetails = data.updateMailData;
            } else {
              this.showMailDetails = [];
            }

            if (data.vehicleTrackData.length > 0) {
              this.consoGRNMail = data.vehicleTrackData;
              this.consoGPSGRNMail = data.vehicleTrackData;
              this.consoGRNMail.forEach((v, i) => {
                console.log(v);
                if (v.status == 1) {
                  this.consoGRNMail[i].status = false;
                }
              });
            } else {
              if (data.consoGRNMail.length > 0) {
                this.consoGRNMail = data.consoGRNMail;
                this.consoGRNMail.forEach((v, i) => {
                  if (v.status == 1) {
                    this.consoGRNMail[i].status = false;
                  }
                });
              } else {
                this.consoGRNMail = [];
                this.consoGPSGRNMail = [];
              }
              // if (data.consoGPSGRNMail.length > 0) {
              //   this.consoGPSGRNMail = data.consoGPSGRNMail;
              // }else{
              //   this.consoGPSGRNMail = [];
              // }
            }

            if (opnMaualTrack == "M") {
              this.addManual();
              this.emailModal.event = "11";
              this.getContent();
            }

            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     $("#truckDetail2").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 22% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}

.margTop-Booking {
  margin-top: 2%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
  height: 10px;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container {
  z-index: 999999 !important;
}
.mx-datepicker-popup {
    position: initial;
}
</style>



// WEBPACK FOOTER //
// tranportMailDetails.vue?a31509d0